import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoadingService } from 'src/app/Service/loading.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { DashBoardService } from 'src/app/User/Pages/dash-board/dash-board.service';
import { SecureFileAuthenticationGuard } from 'src/app/Service/secureFileAuthentication.guard';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 'secure-file-share',
    templateUrl: './secure-file-share.component.html',
    styleUrls: ['./secure-file-share.component.css',],
    standalone: false
})
export class SecureFileShareComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef;
  subscriptions = new Subscription();
  file: File;
  fileInfo: any;
  fileUploaded: boolean;
  constructor(
    public dashboardService: DashBoardService,
    public loaderService: LoadingService,
    // public activeModal: NgbActiveModal,
    public secureFileAuthenticationGuard: SecureFileAuthenticationGuard,
    public modalService: NgbModal,
    public notify: NotificationService,
    private router:Router
  ) {
    this.loaderService.HideLoading();
  }

  ngOnInit(): void {
    this.fileInfo = this.secureFileAuthenticationGuard.info;
  }
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.addDragOverStyles();
  }
 
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.removeDragOverStyles();
  }
 
  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.removeDragOverStyles();
    const file = event.dataTransfer?.files[0];
    if (file) {
      this.file = file;
    }
  }
 
  addDragOverStyles(): void {
    const dropArea = document.querySelector('.drop-area');
    if (dropArea) {
      dropArea.classList.add('drag-over');
    }
  }
 
  removeDragOverStyles(): void {
    const dropArea = document.querySelector('.drop-area');
    if (dropArea) {
      dropArea.classList.remove('drag-over');
    }
  }
  onSave() {
    if (this.file) {
      const formData: any = new FormData();
      formData.append('file', this.file);
      formData.append(
        'value',
        JSON.stringify({
          requestId: this.fileInfo.id,
          passCode: this.fileInfo.passCode,
          fileName: this.file?.name,
          scan: false,
        })
      );
      this.subscriptions.add(
        this.dashboardService.OpenFileUpload(formData).subscribe((response) => {
          if (response.data) {
            this.fileUploaded = true;
            this.file = null;
            this.notify.showSuccess('File has been uploaded.');
            setTimeout(() => {
              this.router.navigateByUrl('/');
            }, 2000);
          }
        })
      );
    }
  }

  OnFileChange(e) {
    this.file = (e.target as HTMLInputElement).files[0];
  }
  onClose() {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
      this.file = null;
    }
    this.modalService.dismissAll();
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
